var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-luko-tracking":"Page-Perks"}},[_c('PerksPageModule',{attrs:{"data":_vm.document}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }